import StartRating from "components/StartRating/StartRating";
import React, { FC, useState, useEffect } from "react";
import config from "config.json";
import useFetch from "hooks/useFetch";
import { useNavigate } from "react-router-dom";

export interface PayPageProps {
  className?: string;
}
interface HotelImage {
  hotel_code: string;
  photos: string[];
}

interface HotelImageDataResponse {
  default_image: string;
  hoteles: HotelImage[];
}

const PayPage: FC<PayPageProps> = ({ className = "" }) => {
  const router = useNavigate();
  const hotel_code = sessionStorage.getItem("selected_hotel");
  const importe = sessionStorage.getItem("preference_amount");
  const operation = sessionStorage.getItem("operation_id");
  const [hotel, setHotel] = useState<any>(null); // Estado inicial para el hotel
  const [hotelImage, setHotelImage] = useState<string>("");
  const { data, isLoading, error, fetchData } = useFetch(
    "GET",
    `${config.backend_url}/setia/hotel/detalle?codigo=${hotel_code}`,
    { "Content-Type": "application/json" }
  );
  const { data: hotelImagesData, error: hotelImagesError, fetchData: fetchHotelImages } = useFetch<HotelImageDataResponse>(
    "GET",
    `${config.backend_url}/setia/hoteles/ver_todas_fotos`,
    { "Content-Type": "application/json" }
  );

  useEffect(() => {

    fetchHotelImages();
    fetchData();

  }, []);

  useEffect(() => {
    if (hotelImagesData) {
      const hotelData = hotelImagesData.hoteles.find(
        (hotel) => hotel.hotel_code === hotel_code
      );
  
      if (hotelData) {
        setHotelImage(hotelData.photos[0]);
      } else {
        setHotelImage(hotelImagesData.default_image);
      }
    }
  }, [hotelImagesData]);

  useEffect(() => {
    if (data) {
      setHotel(data);
    }
  }, [data]);

  const handleExitReservation = () => {

    sessionStorage.removeItem("id_preferencia");
    sessionStorage.removeItem("selected_hotel");
    sessionStorage.removeItem("preference_amount");
    sessionStorage.removeItem("operation_id");
    sessionStorage.removeItem("roomsData");
    sessionStorage.removeItem("start_disp");
    sessionStorage.removeItem("end_disp");
    sessionStorage.removeItem("total_disp");
    sessionStorage.removeItem("guests_checkout");
    sessionStorage.removeItem("occupants");

    router('/account-savelists' , { replace: true });
  
  };

  const renderContent = () => {
    function formatearFecha(fecha: Date) {
      const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
      const dia = fecha.getDate();
      const mes = meses[fecha.getMonth()];
      const anio = fecha.getFullYear();
      return `${dia} de ${mes} ${anio}`;
    }

    let fecha = new Date();
    let fechaFormateada = formatearFecha(new Date());

    let importeReserva = parseFloat(importe!);
   

    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-3xl lg:text-4xl font-semibold">
          Disfruta tu viaje 🎉
        </h2>

        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* ------------------------ */}
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-shrink-0 w-full sm:w-40">
            <div className="aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
              <img
                alt=""
                className="absolute inset-0 object-cover"
                sizes="200px"
                src={hotelImage}
              />
            </div>
          </div>
          <div className="py-5 sm:px-5 space-y-3">
            <div>
              <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1">
                Tu reserva en:
              </span>
              <span className="text-base font-medium mt-1 block">
                {hotel?.descripcion || "Nombre del Hotel"}
              </span>
            </div>

            <div className="w-10 border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">

              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <div className="flex flex-col">
                <span className="">{hotel?.direccion}</span>
                <p className="">{hotel?.ciudad}</p>
              </div>
            </div>
          </div>
        </div>

        {/* ------------------------ */}
        <div className="space-y-6">
          <h3 className="text-2xl font-semibold">Detalles de la reserva</h3>
          <div className="flex flex-col space-y-4">
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Codigo de reserva</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                #{operation}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Fecha</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {fechaFormateada}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Total</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {importeReserva?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
              </span>
            </div>
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1 items-center" style={{ display: 'flex', alignItems: 'center' }}>Metodo de pago</span>
              <span className="flex-1 justify-start items-center font-medium text-neutral-900 dark:text-neutral-100">
                <div className="flex items-center">
                <svg viewBox="0 0 100 60.46" xmlns="http://www.w3.org/2000/svg" className="w-10 h-10">
                  <title>Mercado Pago logo</title>
                  <g>
                    <path d="m307.93,354.9c-23.67,0 -42.87,12.28 -42.87,27.42s19.2,28.61 42.87,28.61s42.87,-13.46 42.87,-28.61s-19.18,-27.42 -42.87,-27.42z" fill="#00b1ea" id="svg_1" transform="translate(-264.25 -353.77)" />
                    <path d="m294,373.84s-0.44,0.47 -0.17,0.82c0.66,0.85 2.71,1.33 4.78,0.87c1.23,-0.28 2.82,-1.53 4.34,-2.75a17.47,17.47 0 0 1 5,-3.16a5.69,5.69 0 0 1 3.62,-0.1a11.3,11.3 0 0 1 3.3,1.93c2.87,2.16 14.43,12.24 16.43,14a110.59,110.59 0 0 1 19,-6c-0.85,-5.17 -4,-10.11 -8.74,-14c-6.66,2.8 -15.34,4.47 -23.3,0.59a22,22 0 0 0 -8.59,-1.95c-6.31,0.15 -9.05,2.88 -11.94,5.77l-3.73,3.98z" fill="#fff" id="svg_2" transform="translate(-264.25 -353.77)" />
                    <path d="m330.77,386.55c-0.14,-0.12 -13.58,-11.89 -16.64,-14.18a7.48,7.48 0 0 0 -3.77,-1.79a5.39,5.39 0 0 0 -1.8,0.17a16.31,16.31 0 0 0 -4.92,2.93c-1.7,1.36 -3.31,2.64 -4.8,3a7.75,7.75 0 0 1 -5.29,-0.79a2.37,2.37 0 0 1 -0.88,-1a1.62,1.62 0 0 1 0.45,-1.76l3.72,-4l1.31,-1.29a24.84,24.84 0 0 0 -3.38,0.76a14.93,14.93 0 0 1 -4,0.74a37.85,37.85 0 0 1 -4,-0.63a66,66 0 0 1 -11.57,-3.87c-5.28,3.93 -8.72,8.75 -9.74,14.16c0.76,0.2 2.74,0.65 3.26,0.77c11.94,2.66 15.66,5.39 16.34,6a3.95,3.95 0 0 1 6.19,0.36a4.55,4.55 0 0 1 2.85,-1a5.39,5.39 0 0 1 1.7,0.3a3.88,3.88 0 0 1 2.4,2.17a4,4 0 0 1 1.66,-0.35a5,5 0 0 1 2,0.44a4.23,4.23 0 0 1 2.35,4.73a3.49,3.49 0 0 1 0.47,0a4.73,4.73 0 0 1 4.17,7a7.51,7.51 0 0 0 4.11,1.1a2.65,2.65 0 0 0 1.93,-0.84c0.12,-0.17 0.25,-0.36 0.13,-0.5l-3.37,-3.74s-0.56,-0.52 -0.37,-0.73s0.54,0.09 0.77,0.29c1.71,1.44 3.8,3.59 3.8,3.59s0.17,0.3 1,0.44a3.51,3.51 0 0 0 2.67,-0.62a5.25,5.25 0 0 0 0.59,-0.6l0,0a1.78,1.78 0 0 0 -0.1,-2.22l-4.01,-4.46s-0.57,-0.52 -0.37,-0.73s0.54,0.1 0.78,0.3c1.24,1 3,2.81 4.69,4.46a3.2,3.2 0 0 0 3.77,-0.13a2.69,2.69 0 0 0 1.39,-2.46a2.83,2.83 0 0 0 -0.84,-1.64l-5.38,-5.4s-0.57,-0.48 -0.36,-0.73s0.54,0.09 0.77,0.29c1.71,1.44 6.34,5.68 6.34,5.68a3.26,3.26 0 0 0 3.64,-0.07a2.45,2.45 0 0 0 1.2,-1.93a2.7,2.7 0 0 0 -0.86,-2.22z" fill="#fff" id="svg_3" transform="translate(-264.25 -353.77)" />
                    <path d="m304.71,393.39a10.73,10.73 0 0 0 -1.86,0.42c-0.06,0 0.05,-0.37 0.13,-0.57s1.18,-3.49 -1.5,-4.64a3.15,3.15 0 0 0 -3.73,0.56c-0.11,0.12 -0.16,0.11 -0.17,0a3,3 0 0 0 -2.08,-2.74a4,4 0 0 0 -4.56,1.63a2.91,2.91 0 1 0 -0.87,2.49s0,0 0,0.1a3.85,3.85 0 0 0 2.41,4.43a2.88,2.88 0 0 0 2.83,-0.44c0.24,-0.16 0.27,-0.1 0.24,0.13c-0.1,0.67 0,2.13 2.06,2.95a2.61,2.61 0 0 0 3.06,-0.57c0.26,-0.24 0.33,-0.2 0.34,0.17a3.69,3.69 0 1 0 3.7,-3.87l0,-0.05z" fill="#fff" id="svg_4" transform="translate(-264.25 -353.77)" />
                    <path d="m43.68,0c-24.12,0 -43.68,12.83 -43.68,28.57l0,1.66c0,16.7 17.1,30.22 43.68,30.22c26.75,0 43.68,-13.52 43.68,-30.22l0,-1.67c0,-15.73 -19.56,-28.56 -43.68,-28.56zm41.71,25.4a100,100 0 0 0 -18.35,6c-4.15,-3.62 -13.72,-11.94 -16.31,-13.89a11.47,11.47 0 0 0 -3.39,-2a5.67,5.67 0 0 0 -1.66,-0.26a7,7 0 0 0 -2.11,0.35a17.14,17.14 0 0 0 -5,3.14l-0.09,0.06c-1.5,1.2 -3.06,2.43 -4.24,2.7a7,7 0 0 1 -1.56,0.17a4,4 0 0 1 -2.95,-1c-0.07,-0.1 0,-0.25 0.15,-0.46l0,0l3.64,-3.93c2.86,-2.86 5.55,-5.55 11.76,-5.7l0.31,0a22.17,22.17 0 0 1 8.16,1.93a25.21,25.21 0 0 0 11.19,2.72a29,29 0 0 0 12.18,-2.91c4.44,3.71 7.37,8.2 8.27,13.08zm-41.71,-23.72c12.8,0 24.26,3.67 32,9.45a27,27 0 0 1 -10.7,2.42a23.65,23.65 0 0 1 -10.41,-2.51a23.39,23.39 0 0 0 -8.88,-2.1l-0.35,0a15.34,15.34 0 0 0 -10.12,3.6a20.17,20.17 0 0 0 -5.06,0.92a13.8,13.8 0 0 1 -3.56,0.69c-0.46,0 -1.27,0 -1.35,0a69.45,69.45 0 0 1 -12.76,-3.53c7.66,-5.49 18.8,-8.93 31.19,-8.93l0,-0.01zm-32.73,10c5.32,2.17 11.79,3.87 13.84,4c0.57,0 1.18,0.11 1.79,0.11a14.78,14.78 0 0 0 4,-0.75c0.77,-0.21 1.63,-0.45 2.53,-0.62c-0.24,0.24 -0.48,0.47 -0.72,0.72l-3.71,4a1.86,1.86 0 0 0 -0.5,2a2.62,2.62 0 0 0 1,1.08a7.75,7.75 0 0 0 3.93,1a7.23,7.23 0 0 0 1.56,-0.16c1.55,-0.34 3.18,-1.65 4.91,-3a16.3,16.3 0 0 1 4.82,-2.88a5.32,5.32 0 0 1 1.35,-0.18a1.73,1.73 0 0 1 0.34,0a7.35,7.35 0 0 1 3.65,1.74c3,2.28 16.5,14.05 16.62,14.17a2.59,2.59 0 0 1 0.8,2a2.16,2.16 0 0 1 -1.07,1.71a3.28,3.28 0 0 1 -1.77,0.55a2.9,2.9 0 0 1 -1.56,-0.45c-0.05,0 -4.66,-4.26 -6.35,-5.69a1.43,1.43 0 0 0 -0.79,-0.43a0.48,0.48 0 0 0 -0.35,0.16c-0.27,0.33 0,0.78 0.39,1.08l5.39,5.41a2.57,2.57 0 0 1 0.75,1.46a2.44,2.44 0 0 1 -1.27,2.23a3.46,3.46 0 0 1 -1.91,0.63a2.69,2.69 0 0 1 -1.53,-0.47l-0.77,-0.76c-1.41,-1.39 -2.87,-2.83 -3.94,-3.72a1.43,1.43 0 0 0 -0.8,-0.42a0.44,0.44 0 0 0 -0.34,0.15c-0.12,0.14 -0.2,0.37 0.1,0.78a2.43,2.43 0 0 0 0.27,0.3l3.93,4.41a1.5,1.5 0 0 1 0.09,1.89l-0.14,0.17c-0.12,0.13 -0.25,0.25 -0.36,0.35a3.18,3.18 0 0 1 -1.92,0.61a2.79,2.79 0 0 1 -0.54,0a1.33,1.33 0 0 1 -0.77,-0.32l-0.05,-0.05c-0.21,-0.22 -2.2,-2.24 -3.83,-3.61a1.34,1.34 0 0 0 -0.76,-0.41a0.46,0.46 0 0 0 -0.35,0.16c-0.32,0.35 0.16,0.89 0.37,1.08l3.35,3.7a0.63,0.63 0 0 1 -0.13,0.22c-0.12,0.16 -0.52,0.57 -1.75,0.73a3.15,3.15 0 0 1 -0.45,0a7.66,7.66 0 0 1 -3.28,-1a5,5 0 0 0 -4.51,-7.12l-0.18,0a4.43,4.43 0 0 0 -2.58,-4.61a5.34,5.34 0 0 0 -2.09,-0.46a4.31,4.31 0 0 0 -1.53,0.28a4.21,4.21 0 0 0 -2.44,-2.08a5.39,5.39 0 0 0 -1.8,-0.31a4.7,4.7 0 0 0 -2.8,0.9a4.24,4.24 0 0 0 -3.29,-1.59a4.3,4.3 0 0 0 -3,1.23c-1,-0.79 -5.18,-3.43 -16.26,-5.95c-0.52,-0.12 -1.72,-0.46 -2.49,-0.69c1.06,-4.97 4.22,-9.51 8.9,-13.24l0,-0.04zm20.54,28.84l-0.12,-0.11l-0.12,0a0.62,0.62 0 0 0 -0.34,0.14a2.86,2.86 0 0 1 -1.66,0.59a2.61,2.61 0 0 1 -0.92,-0.18a3.58,3.58 0 0 1 -2.24,-4.16a0.37,0.37 0 0 0 -0.11,-0.34l-0.18,-0.15l-0.17,0.16a2.67,2.67 0 1 1 0.78,-2.26l0.1,0.72l0.4,-0.61a3.91,3.91 0 0 1 3.11,-1.7a4.07,4.07 0 0 1 1.16,0.18a2.7,2.7 0 0 1 1.89,2.51c0,0.34 0.28,0.36 0.32,0.36a0.44,0.44 0 0 0 0.31,-0.16a2.69,2.69 0 0 1 2,-0.82a3.63,3.63 0 0 1 1.47,0.33c2.51,1.08 1.37,4.26 1.36,4.3c-0.21,0.52 -0.23,0.76 0,0.9l0.1,0l0.07,0a1.53,1.53 0 0 0 0.48,-0.13a4.33,4.33 0 0 1 1.34,-0.3a3.47,3.47 0 0 1 3.43,3.43a3.42,3.42 0 0 1 -6.84,0.15c0,-0.16 0,-0.58 -0.37,-0.58a0.68,0.68 0 0 0 -0.42,0.21a2.41,2.41 0 0 1 -1.68,0.76a2.88,2.88 0 0 1 -1.1,-0.24c-1.95,-0.79 -2,-2.13 -1.9,-2.67a0.38,0.38 0 0 0 -0.15,-0.29l0,-0.04zm12.19,14.87c-23.2,0 -42,-12 -42,-26.88c0,-0.6 0,-1.19 0.1,-1.78l2.41,0.57c11.31,2.52 15,5.13 15.68,5.62a4.25,4.25 0 0 0 3.88,5.91a3.88,3.88 0 0 0 0.78,-0.07a5,5 0 0 0 3.2,3.7a4.2,4.2 0 0 0 1.51,0.29a4.24,4.24 0 0 0 1,-0.12a4.92,4.92 0 0 0 4.3,2.81a3.6,3.6 0 0 0 1.3,-0.24a5,5 0 0 0 8.19,1.59a9.34,9.34 0 0 0 4.23,1.26a4.24,4.24 0 0 0 0.64,0a3.9,3.9 0 0 0 2.87,-1.4a1.88,1.88 0 0 0 0.18,-0.29a4.76,4.76 0 0 0 1.36,0.21a4.58,4.58 0 0 0 2.73,-1a3.81,3.81 0 0 0 1.62,-2.35l0,0a4.38,4.38 0 0 0 0.91,0.1a5.08,5.08 0 0 0 2.81,-0.89a4,4 0 0 0 2,-3.61a4.58,4.58 0 0 0 0.93,0.1a4.81,4.81 0 0 0 2.64,-0.81a3.83,3.83 0 0 0 1.83,-3a4.08,4.08 0 0 0 -0.58,-2.41a108.86,108.86 0 0 1 17.44,-5.47c0,0.44 0.05,0.89 0.05,1.34c0,14.83 -18.81,26.86 -42.01,26.86l0,-0.04z" fill="#2d3277" id="svg_5" />
                  </g>
                </svg>
                Mercado Pago
                </div>
              </span>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <button onClick={handleExitReservation} className="bg-primary-6000 hover:bg-primary-7000 text-white py-2 px-4 rounded-full mt-4 w-auto">Ir a mis reservas</button>
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-PayPage ${className}`} data-nc-id="PayPage">
      <main className="container mt-11 mb-24 lg:mb-32 ">
        <div className="max-w-4xl mx-auto">{renderContent()}</div>
      </main>
    </div>
  );
};

export default PayPage;
